import React, { useMemo } from 'react';
import SearchFilterItem from '../SearchFilterItem/SearchFilterItem';
import {
  CustomAttributesTypes,
  UnionCustomAttributeProps
} from 'components/common/Portals/CustomAttributes/types';
import { Divider } from '@mui/material';
import SearchFilterHeader from '../SearchFilters/SearchFilterHeader';

export const BrandPortalFilters: React.FC<{
  companyAttributeDefinitions?: UnionCustomAttributeProps[];
  productAttributeDefinitions?: UnionCustomAttributeProps[];
}> = props => {
  const filterOptions = useMemo(() => {
    if (
      props.companyAttributeDefinitions &&
      props.productAttributeDefinitions
    ) {
      return [
        ...props.companyAttributeDefinitions,
        ...props.productAttributeDefinitions
      ]
        .filter(d => d.filterable)
        .map(d => ({ key: d.key, label: d.name, type: d.type }))
        .sort((a, b) => a.label.localeCompare(b.label))
        .sort((a, b) =>
          a.type === CustomAttributesTypes.TEXT
            ? -1
            : b.type === CustomAttributesTypes.TEXT
            ? 1
            : 0
        );
    }
  }, [props.companyAttributeDefinitions, props.productAttributeDefinitions]);
  const firstTextIndex = filterOptions?.findIndex(
    option => option.type === CustomAttributesTypes.TEXT
  );
  return filterOptions?.length ? (
    <div className="search-filters search-filters-custom">
      <div className="search-filters-body">
        <SearchFilterHeader title="Custom Filters" />
        <Divider sx={{ borderColor: 'primary.main' }} />

        {filterOptions.map((option, index) => (
          <SearchFilterItem
            key={option.key}
            option={option}
            isFirstTextFilter={index === firstTextIndex}
          />
        ))}
      </div>
    </div>
  ) : null;
};
